import { render, staticRenderFns } from "./AudioShopUpload.vue?vue&type=template&id=03965360&scoped=true"
import script from "./AudioShopUpload.vue?vue&type=script&lang=ts"
export * from "./AudioShopUpload.vue?vue&type=script&lang=ts"
import style0 from "./AudioShopUpload.vue?vue&type=style&index=0&id=03965360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03965360",
  null
  
)

export default component.exports